import React from "react";
import "./banner.scss";
import classNames from "classnames";
import { bannerSentiment } from "./bannerUtils";
import { FaTimes } from "react-icons/fa";
import { withDefaults } from "../../utils/withDefaults";
import type { BannerSentiment } from "./bannerUtils";

export interface BannerProps {
  message?: string;
  sentiment?: BannerSentiment;
  isBannerVisible?: boolean;
  shouldShowBannerClose?: boolean;
  onBannerClose?: () => void;
}

export default function Banner(incomingProps: BannerProps) {
  const props = withDefaults(incomingProps, bannerDefaultProps);

  return props.isBannerVisible ? (
    <div className={classNames("banner", props.sentiment)}>
      {props.message}
      {props.shouldShowBannerClose ? (
        <FaTimes onClick={props.onBannerClose} className="banner-close" />
      ) : null}
    </div>
  ) : null;
}

const bannerDefaultProps = {
  message: "",
  sentiment: bannerSentiment.NEUTRAL,
  isBannerVisible: true,
  shouldShowBannerClose: false,
  onBannerClose: () => {}
};
